import React from "react";
import { Navigate,useLocation } from "react-router-dom";
import { useLogin } from "../../context/LoginContext";
import { hasRoutePermission } from '../../utils/rolemap';

const PrivateRoute = ({ children }) => {
  const { isLoggedIn,user } = useLogin();
  const mobileNumber = user?.mobileNumber;
  const location = useLocation();
  const route = location.pathname;
  if (!isLoggedIn) {
    return <Navigate to="/" />;
  }
  if (!mobileNumber || !hasRoutePermission(mobileNumber, route)) {
    return <Navigate to="/notfound" />;
  }
  return children;
};

export default PrivateRoute;